export default __webpack_public_path__ + "static/media/byMonth.5613bbc9.png";